import React from "react";
import Chart from "react-apexcharts";

const legenddata = [
  {
    name: "Overload Diagram",
    color: "#ff6b6b",
  },
  {
    name: "Load Diagram",
    color: "#51cf66",
  },
  {
    name: "Engine Design Curve (Propeller Curve)",
    color: "#1c7ed6",
  },
  {
    name: "Propeller Design Curve (Light Running)",
    color: "#74c0fc",
  },
  {
    name: "Orange Curve",
    color: "#ff8c00",
  },
  {
    name: "Blue Curve",
    color: "#0066cc",
  },
  {
    name: "Dataset",
    color: "#9888ffff",
  },
];

const PropellerLayoutCurve = () => {
    const data = {
    load_percentage: 75,
    turbo_rpm_percentage: 90
  };
  const dynamicDatasets = [
    {
      name: "Dataset 1 (s1)",
      yValues: [(data && data?.load_percentage) ? data?.load_percentage : 75],
      xOffset: (data && data?.turbo_rpm_percentage) ? data?.turbo_rpm_percentage : 90,
      color: "#9888ffff",
    },
  ];

  // Function to scale and adjust original series based on dynamic datasets
  const generateAdaptiveBoundaries = (datasets) => {
    // Find the extent of all dynamic data
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;

    datasets.forEach(({ yValues, xOffset }) => {
      yValues.forEach((y, i) => {
        const x = xOffset + i * 1.5;
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
      });
    });

    // Original series template - maintain the exact structure
    const originalTemplate = {
      overload: [
        [67.5634, 49.99229], [72.95771, 58.45455], [76.62636, 64.48056], [80.29501, 70.75766],
        [83.96365, 77.46707], [87.6323, 84.3293], [91.30095, 91.6675], [94.9696, 99.25679],
        [100.0099, 109.8178], [102.3069, 109.9115], [104.9545, 109.858], [105.0442, 100.137],
      ],
      load: [
        [69.69195, 50.08465], [74.97187, 58.03316], [78.64052, 63.84958], [82.30917, 69.50616],
        [85.97781, 76.34483], [89.64646, 83.00401], [93.31511, 89.96887], [96.98375, 97.11979],
        [100.0953, 100.0128], [105.0039, 100.1105], [105.0198, 78.1439], [105.0044, 62.91807], [105.0044, 49.89515],
      ],
      engine: [
        [79.54731, 50.20757], [85.03239, 61.40424], [88.69576, 69.65219],
        [92.47717, 79.00862], [96.11155, 88.6897], [100.046, 100.0738],
      ],
      propeller: [
        [83.46551, 50.08737], [89.03386, 60.91813], [92.5656, 68.39297],
        [96.30038, 77.06751], [100.0115, 86.31296], [105.0349, 100.2175],
      ],
      // New orange curve - positioned between engine and propeller curves
      orangeCurve: [
        [81.5, 50.15], [87.0, 61.16], [90.6, 68.9], 
        [94.2, 78.0], [98.1, 87.5], [102.5, 98.2],
      ],
      // New blue curve - positioned above the orange curve
      blueCurve: [
        [80.0, 52.0], [85.5, 63.0], [89.1, 71.5],
        [93.0, 81.0], [97.0, 90.5], [101.5, 102.0],
      ]
    };

    // Calculate scaling factors to ensure dynamic data fits within boundaries
    const xMargin = Math.max((maxX - minX) * 0.2, 20);
    const yMargin = Math.max((maxY - minY) * 0.5, 30);

    const targetMinX = minX - xMargin;
    const targetMaxX = maxX + xMargin;
    const targetMinY = minY - yMargin;
    const targetMaxY = maxY + yMargin;

    // Find original boundaries
    const origMinX = Math.min(...Object.values(originalTemplate).flat().map(([x, y]) => x));
    const origMaxX = Math.max(...Object.values(originalTemplate).flat().map(([x, y]) => x));
    const origMinY = Math.min(...Object.values(originalTemplate).flat().map(([x, y]) => y));
    const origMaxY = Math.max(...Object.values(originalTemplate).flat().map(([x, y]) => y));
    console.log("targetMaxY",targetMaxY);
    console.log("targetMinY",targetMinY);
    console.log("origMaxY",origMaxY);
    
    // Calculate scaling factors
    const xScale = (targetMaxX - targetMinX) / (origMaxX - origMinX);
    const yScale = (targetMaxY - targetMinY) / (origMaxY - origMinY);

    // Apply scaling while maintaining structure
    const scalePoint = ([x, y]) => [
      targetMinX + (x - origMinX) * xScale,
      targetMinY + (y - origMinY) * yScale
    ];

    const scaledTemplate = {
      overload: originalTemplate.overload.map(scalePoint),
      load: originalTemplate.load.map(scalePoint),
      engine: originalTemplate.engine.map(scalePoint),
      propeller: originalTemplate.propeller.map(scalePoint),
      orangeCurve: originalTemplate.orangeCurve.map(scalePoint),
      blueCurve: originalTemplate.blueCurve.map(scalePoint)
    };
    console.log("scaledTemplate",scaledTemplate)
    return {
      series: [
        {
          name: "Overload Diagram",
          data: scaledTemplate.overload.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#ff6b6b",
        },
        {
          name: "Load Diagram",
          data: scaledTemplate.load.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#51cf66",
        },
        {
          name: "Engine Design Curve (Propeller Curve)",
          data: scaledTemplate.engine.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#1c7ed6",
        },
        {
          name: "Propeller Design Curve (Light Running)",
          data: scaledTemplate.propeller.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#74c0fc",
        },
        {
          name: "Orange Curve",
          data: scaledTemplate.orangeCurve.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#ff8c00",
        },
        {
          name: "Blue Curve",
          data: scaledTemplate.blueCurve.map(([x, y]) => ({ x, y })),
          type: "line",
          color: "#0066cc",
        },
      ],
      scaledTemplate
    };
  };

  // Generate colored background zones using scaled boundaries
  const generateColoredZones = (scaledTemplate, chartBounds) => {
    const { overload, load, engine, propeller } = scaledTemplate;
    const { minX, maxX, minY, maxY } = chartBounds;

    return [
      {
        name: "Overload Zone",
        data: [
          ...overload.map(([x, y]) => ({ x, y })),
          ...load.slice().reverse().map(([x, y]) => ({ x, y })),
        ],
        type: "area",
        color: "#ff4757",
        fillOpacity: 0.5,
      },
      // Green zone (between load diagram and engine design curve)
      {
        name: "Operating Zone",
        data: [
          ...load.slice(0, 9).map(([x, y]) => ({ x, y })), // First part of load curve
          ...engine.slice().reverse().map(([x, y]) => ({ x, y })),
        ],
        type: "area",
        color: "#f3e17aff",
        fillOpacity: 0.5,
      },
      // Blue zone (between engine design curve and propeller design curve)
      {
        name: "Efficient Zone",
        data: [
          ...engine.map(([x, y]) => ({ x, y })),
          ...propeller.slice().reverse().map(([x, y]) => ({ x, y })),
        ],
        type: "area",
        color: "#62f0a2ff",
        fillOpacity: 0.5,
      },
      // Light blue zone (below propeller design curve)
      {
        name: "Light Running Zone",
        data: [
          ...propeller.map(([x, y]) => ({ x, y })),
          { x: propeller[propeller.length - 1][0], y: minY },
          { x: propeller[0][0], y: minY },
        ],
        type: "area",
        color: "#99ebfaff",
        fillOpacity: 0.4,
      },
    ];
  };

  const { series: boundaryLines, scaledTemplate } = generateAdaptiveBoundaries(dynamicDatasets);

  // Create dynamic series as simple line charts
  const dynamicSeries = dynamicDatasets.map(({ name, yValues, xOffset, color }) => {
    const points = yValues.map((y, i) => ({ x: xOffset + i * 1.5, y }));

    return {
      name,
      data: points,
      type: "line",
      color,
      marker: { size: 5 },
    };
  });

  // Calculate dynamic X and Y ranges from boundary lines
  const allXValues = [];
  const allYValues = [];

  // Extract X and Y values from boundary series
  [...boundaryLines, ...dynamicSeries].forEach(series => {
    series.data.forEach(point => {
      allXValues.push(point.x);
      allYValues.push(point.y);
    });
  });

  // Calculate chart bounds
  const xMinRaw = Math.min(...allXValues);
  const xMaxRaw = Math.max(...allXValues);
  const xRange = xMaxRaw - xMinRaw;
  const xPadding = Math.max(xRange * 0.1, 5);
  const xMin = Math.max(0, xMinRaw - xPadding);
  const xMax = xMaxRaw + xPadding;

  const yMinRaw = Math.min(...allYValues);
  const yMaxRaw = Math.max(...allYValues);
  const yRange = yMaxRaw - yMinRaw;
  const yPadding = Math.max(yRange * 0.1, 10);
  const yMin = Math.max(0, yMinRaw - yPadding);
  const yMax = yMaxRaw + yPadding;

  // Generate colored zones
  const coloredZones = generateColoredZones(scaledTemplate, {
    minX: xMin,
    maxX: xMax,
    minY: yMin,
    maxY: yMax
  });

  // Combine all series with background areas first
  const allSeries = [...coloredZones, ...boundaryLines, ...dynamicSeries];

  const toggleSeries = (seriesName) => {
    // Toggle series functionality - you can implement this if needed
    console.log(`Toggle series: ${seriesName}`);
  };

  const chartOptions = {
    chart: {
      type: "line",
      height: 600,
      background: "#fff",
      toolbar: { show: false },
      zoom: {
        enabled: false,
      },
      stacked: false,
    },

    xaxis: {
      title: { text: "RPM %", style: { fontSize: "14px", color: "#333" } },
      min: xMin,
      max: xMax,
      tickAmount: 10,
      labels: { formatter: (val) => Math.round(val) },
      axisBorder: { show: true, color: "#e0e0e0" },
      axisTicks: { show: true, color: "#e0e0e0" },
    },

    yaxis: {
      title: { text: "MCR %", style: { fontSize: "14px", color: "#333" } },
      min: yMin,
      max: yMax,
      tickAmount: 10,
      labels: { formatter: (val) => Math.round(val) },
      axisBorder: { show: true, color: "#e0e0e0" },
      axisTicks: { show: true, color: "#e0e0e0" },
    },

    grid: {
      show: true,
      borderColor: "#e0e0e0",
      strokeDashArray: 0,
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: true } },
    },

    stroke: {
      width: allSeries.map((s, index) => {
        if (s.type === "area") return 0;
        // Make orange and blue curves thicker
        if (index >= coloredZones.length + 4 && index < coloredZones.length + 6) return 3;
        return index >= coloredZones.length + 6 ? 2 : 2;
      }),
      curve: "straight",
      dashArray: allSeries.map((s, index) =>
        index >= coloredZones.length + 6 ? 5 : 0
      ),
    },

    fill: {
      type: allSeries.map((s) => (s.type === "area" ? "solid" : "solid")),
      opacity: allSeries.map((s) => (s.type === "area" ? (s.fillOpacity || 0.3) : 1)),
    },

    markers: {
      size: allSeries.map((s, index) => (index >= coloredZones.length + 6 ? 6 : 0)),
      shape: "circle",
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: { size: 7 },
    },

    // Data labels configuration - shows values directly on chart
    dataLabels: {
      enabled: true,
      enabledOnSeries: allSeries.map((series, index) => 
        index >= coloredZones.length + 6 ? index : null
      ).filter(x => x !== null),
      formatter: function (val, opts) {
        const xVal = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x;
        return `(${Number(xVal).toFixed(1)}, ${Number(val).toFixed(1)})`;
      },
      textAnchor: 'middle',
      offsetY: -10,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#6366f1']
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        borderRadius: 2,
        padding: 2,
        opacity: 0.8
      }
    },

    legend: { show: false },

    tooltip: {
      shared: false,
      intersect: true,
      x: { formatter: (val) => `RPM: ${val.toFixed(2)}%` },
      y: { formatter: (val) => `MCR: ${val.toFixed(2)}%` },
    },
  };

  return (
    <div className="p-4">
      <Chart options={chartOptions} series={allSeries} type="line" height={400} />
      
      <div className="d-flex flex-wrap">
        {legenddata.map((s, i) => (
          <div
            key={i}
            className="d-flex align-items-center ms-3 mb-2 cursor-pointer"
            onClick={() => toggleSeries(s.name)}
            style={{ cursor: "pointer" }}
          >
            <span
              className="me-1 rounded"
              style={{
                width: "8px",
                height: "8px",
                display: "inline-block",
                backgroundColor: s.color,
              }}
            />
            <span className="fs-12">{s.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
 export default PropellerLayoutCurve